"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NovageSkincareAdvisorController", {
  enumerable: true,
  get: function () {
    return _containers.NovageSkincareAdvisorController;
  }
});
Object.defineProperty(exports, "OPEN_HREF_ATTRIBUTE", {
  enumerable: true,
  get: function () {
    return _constants.OPEN_HREF_ATTRIBUTE;
  }
});
Object.defineProperty(exports, "defaultTranslations", {
  enumerable: true,
  get: function () {
    return _constants.defaultTranslations;
  }
});
Object.defineProperty(exports, "translationsNamespace", {
  enumerable: true,
  get: function () {
    return _constants.translationsNamespace;
  }
});
var _containers = require("./containers");
var _constants = require("./constants");